import React from "react";
import { MapPin } from "lucide-react";

const REUNION_IMG =
  "https://images.unsplash.com/photo-1683020369776-fc8dee039740?auto=format&fit=crop&w=1800&q=80";

const towns = [
  "Saint-Denis",
  "Saint-Paul",
  "Saint-Pierre",
  "Le Tampon",
  "Saint-Benoît",
  "Saint-André",
  "Saint-Louis",
  "Le Port",
  "La Possession",
  "Saint-Joseph",
];

export default function Zone() {
  return (
    <section
      id="zone"
      data-testid="zone-section"
      className="relative overflow-hidden bg-stone-900 py-24 text-stone-100 sm:py-32"
    >
      <img
        src={REUNION_IMG}
        alt="Paysage côtier de l'Île de la Réunion"
        className="absolute inset-0 h-full w-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/80 to-stone-900/60" />

      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:items-end">
          <div className="md:col-span-7">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-stone-50/20 bg-stone-50/5 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-stone-100">
              <MapPin className="h-3.5 w-3.5" strokeWidth={1.5} /> 974 · Réunion
            </div>
            <h2 className="text-3xl font-light leading-tight tracking-tight sm:text-5xl">
              Toute l'île,
              <br />
              <span className="italic text-orange-200">d'un littoral à l'autre.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base text-stone-300">
              Basé à Saint-Paul, j'interviens sur toute l'Île de la Réunion. Études
              sur site, suivi de chantier et livraisons coordonnées en local.
            </p>
          </div>

          <div className="md:col-span-5">
            <div className="rounded-2xl border border-stone-50/15 bg-stone-50/5 p-6 backdrop-blur-xl sm:p-8">
              <p className="mb-4 text-xs uppercase tracking-[0.25em] text-stone-300">
                Villes desservies
              </p>
              <ul className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
                {towns.map((t) => (
                  <li key={t} className="flex items-center gap-2 text-stone-200">
                    <span className="h-1 w-1 rounded-full bg-orange-300" />
                    {t}
                  </li>
                ))}
              </ul>
              <p className="mt-5 text-xs text-stone-400">
                Et toutes les autres communes sur demande.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
